import React, {useState} from 'react';

import 'styles/components/FacilityLiveAuctionTile.less';

const FacilityLiveAuctionTile = ({ auction }) => {
    const [isExpired, setIsExpired] = useState(false);
    const [validExpiredTime, setValidExpiredTime] = useState(true);

    const getUnitCount = () => {
        const { unit_count } = auction;
        return isNaN(unit_count) || !parseInt(unit_count)
            ? (
              <>
                Call for
                  {' '}
                 <br className="d-sm-none" />
                  Details
              </>
)
            : <div className="large-number">{unit_count}</div>;
    };

    const { date_formatted, time_formatted } = auction?.expire_date.user;

    return (
      <div className={`d-flex align-items-center facility-live-auction-tile text-center live-auction-id-${auction?.live_auction_id}${isExpired ? ' expired' : ''}${validExpiredTime ? '' : ' invalidExpiredTime'}`}>
        <div className="d-flex flex-column justify-content-center flex-1 border h-100 half">
          <div className="title">Date/Time:</div>
          <div className="body date">
            {date_formatted}
            {' '}
            -
            <br className="d-sm-none" />
            {time_formatted}
          </div>
        </div>
        <div className="d-flex flex-column justify-content-center flex-1 border border-left-0 h-100 half">
          <div className="title"># of Units:</div>
          <div className="body count">
            {getUnitCount()}
          </div>
        </div>
      </div>
    );
}


export default FacilityLiveAuctionTile;
